import loadable from '@loadable/component';

import * as constants from './constants';

export { collectionInfoLookup, orderCollections } from './utils';
export { constants };

const CollectionsBucket = loadable(() => import('./CollectionsBucket'));

export { CollectionsBucket };
